import styled, { css } from 'styled-components';
import { ctaStyles, disabled } from '../../styles/components.js';
import { Backdrop } from '../../styles/stories.js';
import { addContentMask, addBackgroundMask } from '../../utils/color-manipulation.js';
import 'react';

const darkenBackground = (props) => css `
  background: ${addBackgroundMask({
    color: props.backgroundColor,
    props,
})};
`;
const lightenBackground = (props) => css `
  background: ${addBackgroundMask({
    color: props.backgroundColor,
    lighten: true,
    props,
})};
`;
const modeBorderStyles = (props) => {
    switch (props.mode) {
        case 'default':
        case 'destructiveOutline':
            return css `
        border: 1px solid ${props.theme.colors.background.controls};
      `;
        case 'outline':
            return css `
        border: 2px solid ${props.theme.colors.background.primaryInverse};
      `;
        default:
            return css `
        border: none;
      `;
    }
};
const modeHoverStyles = (props) => {
    switch (props.mode) {
        case 'default':
        case 'destructiveOutline':
            return css `
        border: 1px solid ${props.theme.colors.background.primaryInverse};
      `;
        default:
            return css `
        ${darkenBackground}
      `;
    }
};
const modeActiveStyles = (props) => {
    switch (props.mode) {
        case 'default':
            return css `
        background-color: ${props.theme.colors.background.secondary};
        box-shadow: none;
      `;
        case 'destructiveOutline':
            return css `
        ${darkenBackground}
        box-shadow: none;
      `;
        default:
            return css `
        ${lightenBackground}
        box-shadow: none;
      `;
    }
};
const modeFocusStyles = (props) => {
    switch (props.mode) {
        case 'default':
        case 'destructiveOutline':
        case 'outline':
            return css `
        border-color: ${props.theme.colors.content.blue};
        outline: 2px solid
          ${addContentMask({ color: 'blue', lighten: true, props })};
      `;
        case 'ghost':
            return css `
        ${darkenBackground}
        outline: 2px solid ${addContentMask({
                color: 'blue',
                lighten: true,
                props,
            })};
      `;
        case 'primary':
        case 'destructive':
        default:
            return css `
        outline: 2px solid ${props.theme.colors.content.blue};
        outline-offset: 1px;
      `;
    }
};
const modeShadowStyles = (props) => {
    switch (props.mode) {
        case 'default':
        case 'primary':
        case 'destructive':
        case 'destructiveOutline':
            return css `
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
      `;
        case 'outline':
        case 'ghost':
        default:
            return css `
        box-shadow: none;
      `;
    }
};
const heightForSize = (props) => {
    switch (props.size) {
        case 'small':
            return css `
        height: 32px;
      `;
        case 'large':
            return css `
        height: 48px;
      `;
        case 'medium':
        default:
            return css `
        height: 40px;
      `;
    }
};
const StyledButton = styled.button `
  background: ${props => props.theme.colors.background[props.backgroundColor]};
  color: ${props => props.theme.colors.content[props.color]};

  ${ctaStyles}

  ${modeShadowStyles}

  ${modeBorderStyles}

  ${heightForSize}

  &:hover {
    ${modeHoverStyles}
  }

  &:active {
    ${modeActiveStyles}
  }

  &:focus-visible {
    ${modeFocusStyles}
  }

  &:disabled {
    ${disabled}
  }
`;
const ColorsForMode = {
    default: {
        backgroundColor: 'primary',
        color: 'primary',
    },
    primary: {
        backgroundColor: 'primaryInverse',
        color: 'accent1',
    },
    outline: {
        backgroundColor: 'transparent',
        color: 'primary',
    },
    ghost: {
        backgroundColor: 'transparent',
        color: 'blue',
    },
    control: {
        backgroundColor: 'transparent',
        color: 'primary',
    },
    destructive: {
        backgroundColor: 'errorDark',
        color: 'primaryInverse',
    },
    destructiveOutline: {
        backgroundColor: 'primary',
        color: 'error',
    },
};
// Used in storybook only
styled(Backdrop).attrs({ height: 150 }) `
  background-color: rgb(250, 250, 250);

  & > * {
    margin: 0;
  }

  & > :first-child {
    margin-top: 8px;
  }

  & > :last-child {
    margin-top: 16px;
  }
`;

export { ColorsForMode, StyledButton };
